module.exports = __webpack_public_path__ + "static/media/logo2.ac47a827.png";